import styled from '@emotion/styled';
import { SizedCell as KizenSizedCell } from '__components/Kizen/Table';
import { getSizing, PADDING } from '__pages/Common/components/BigTableCells';

const SizedCell = styled(({ column, minWidth, getColumnWidth, ...others }) => {
  const width = getColumnWidth && getColumnWidth(column.id);

  return (
    <KizenSizedCell
      column={column}
      padding={`${PADDING}px`}
      {...getSizing(width, minWidth)}
      {...others}
    />
  );
})`
  > div {
    // Fixes small alignment issue with cell text
    line-height: 0;
    margin-top: 1px;
  }
`;
export default SizedCell;
